import { type ReactNode } from 'react';
import { Input } from '@/components/ui/input';
import { Select } from '@/components/ui/select';
import { categoryOptions, parseCategoryValue } from '@/utils/creator-helpers';
import { useAuth } from '@/hooks/use-auth';
import { usePipelineFilters } from '../hooks/use-pipeline-filters';
import {
  CollectorFilter,
  ClearFiltersButton,
} from './pipeline-filter-controls';

const OPTS = categoryOptions();

function CategorySelect(): ReactNode {
  const { category, creator_type, setCategorySel } = usePipelineFilters();
  const value = category && creator_type ? `${creator_type}:${category}` : '';
  return (
    <div className="w-full sm:w-48">
      <Select
        value={value}
        onChange={(e) =>
          setCategorySel(parseCategoryValue(e.target.value) ?? undefined)
        }
      >
        <option value="">Categoría</option>
        {OPTS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </Select>
    </div>
  );
}

export function PipelineFilters(): ReactNode {
  const f = usePipelineFilters();
  const { isAdmin } = useAuth();
  const active = f.search || f.category || f.collector;
  return (
    <div className="flex flex-wrap items-end gap-sm">
      <div className="w-full sm:w-48">
        <Input
          placeholder="Buscar..."
          value={f.search}
          onChange={(e) => f.setSearch(e.target.value)}
        />
      </div>
      <CategorySelect />
      {isAdmin && (
        <CollectorFilter value={f.collector ?? ''} onChange={f.setCollector} />
      )}
      {active && <ClearFiltersButton onClick={f.clearFilters} />}
    </div>
  );
}
